import FlowConfigBase from '#client/config/FlowConfigBase';
import PAGES, { PAGE_KEYS } from '#client/config/flowPageConfig';
import * as ROUTES from '#client/constants/routes';

export default FlowConfigBase.createEntry({
  id: 'llc',
  pageKeys: [
    PAGE_KEYS.GUARANTEE,
    PAGE_KEYS.QUESTIONS,
    PAGE_KEYS.PRODUCTS_PHONE,
    PAGE_KEYS.CHECKOUT
  ],
  pageConfigs: {
    [PAGES.QUESTIONS.pageComponent]: {
      pageComponentProps: {
        formationCountyStates: new Set(['NY'])
      }
    },
    [PAGES.PRODUCTS_PHONE.pageComponent]: {
      pageComponentProps: {
        couponCodes: {
          worry_free_service: '199_off_first_year'
        }
      }
    },
    [PAGES.CHECKOUT.pageComponent]: {
      pageComponentProps: {
        checkFormFactorFlag: true
      }
    }
  },
  currentExperiment: null,
  featureFlags: {},
  hasFormation: true,
  entityType: 'llc',
  isPrimary: true,
  postOrderAutoLogin: true,
  postOrderRedirect: ROUTES.SHOP_LLC_ADDONS,
  priceListUuids: {
    development: '3c9da872-c96d-4e28-be04-4dd8cf8e1a2e',
    production: '19a705a4-3241-4f65-aef1-74a95f6f49b8'
  }
});
